/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
import {formatMoney} from '@shopify/theme-currency';
import {getSizedImageUrl} from '@shopify/theme-images';

import showElement from '../util/show-element';

Shopify.Products = (function () {
  const config = {
    howManyToShow: 4,
    howManyToStoreInMemory: 10,
    wrapperId: 'recently-viewed-products',
    templateId: 'recently-viewed-product-template',
    onComplete: null,
  };

  let productHandleQueue = [];
  let wrapper = null;
  let template = null;
  let howManyToShowItems = null;

  const cookie = {
    configuration: {
      expires: 90,
      path: '/',
      domain: window.location.hostname,
    },
    name: 'shopify_recently_viewed',
    write: function (recentlyViewed) {
      const recentlyViewedString = recentlyViewed.join(' ');
      document.cookie = `${this.name}=${recentlyViewedString}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
    },
    read: function () {
      let recentlyViewed = [];
      let cookieValue = null;
      const templateProduct = document.querySelector('#template-product');

      if (templateProduct) {
        const currentProduct = templateProduct.getAttribute('data-product-handle');

        if (document.cookie.indexOf('; ') !== -1 && document.cookie.split('; ').find((row) => row.startsWith(this.name))) {
          cookieValue = document.cookie
            .split('; ')
            .find((row) => row.startsWith(this.name))
            .split('=')[1];
        }

        if (cookieValue !== null) {
          recentlyViewed = cookieValue.split(' ');
        }

        // Remove current product from the array
        if (recentlyViewed.indexOf(currentProduct) != -1) {
          const currentProductIndex = recentlyViewed.indexOf(currentProduct);
          recentlyViewed.splice(currentProductIndex, 1);
        }
      }

      return recentlyViewed;
    },
    destroy: function () {
      const cookieVal = null;
      document.cookie = `${this.name}=${cookieVal}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
    },
    remove: function (productHandle) {
      const recentlyViewed = this.read();
      const position = recentlyViewed.indexOf(productHandle);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    },
  };

  const finalize = () => {
    showElement(wrapper, true);
    const cookieItemsLength = cookie.read().length;

    if (Shopify.recentlyViewed && howManyToShowItems && cookieItemsLength && cookieItemsLength < howManyToShowItems && wrapper.children.length) {
      let allClassesArr = [];
      let addClassesArr = [];
      let objCounter = 0;
      for (const property in Shopify.recentlyViewed) {
        objCounter += 1;
        const objString = Shopify.recentlyViewed[property];
        const objArr = objString.split(' ');
        const propertyIdx = parseInt(property.split('_')[1]);
        allClassesArr = [...allClassesArr, ...objArr];

        if (cookie.read().length === propertyIdx || (objCounter === Object.keys(Shopify.recentlyViewed).length && !addClassesArr.length)) {
          addClassesArr = [...addClassesArr, ...objArr];
        }
      }

      for (let i = 0; i < wrapper.children.length; i++) {
        const element = wrapper.children[i];
        if (allClassesArr.length) {
          element.classList.remove(...allClassesArr);
        }

        if (addClassesArr.length) {
          element.classList.add(...addClassesArr);
        }
      }
    }

    // If we have a callback.
    if (config.onComplete) {
      try {
        config.onComplete();
      } catch (error) {
        console.log('error');
      }
    }
  };

  const moveAlong = (shown) => {
    if (productHandleQueue.length && shown < config.howManyToShow) {
      fetch('/products/' + productHandleQueue[0] + '.js')
        .then((response) => response.json())
        .then((product) => {
          product.priceFormatted = formatMoney(product.price, theme.moneyFormat);
          product.compareFormatted = formatMoney(product.compare_at_price, theme.moneyFormat);
          product.topImage = product.media[0] ? getSizedImageUrl(product.media[0].preview_image.src, '900x900') : '';
          product.bottomImage = product.media[1] ? getSizedImageUrl(product.media[1].preview_image.src, '900x900') : '';

          let customBadgeVal;
          let customBadge = false;
          let preorder = false;
          let doubleImageClass = '';
          let bottomImageClass = '';
          let customBadgeClass = 'is-hidden hidden';
          let preorderClass = 'is-hidden hidden';
          let saleClass = 'is-hidden hidden';
          let salePriceClass = 'is-hidden hidden';
          let priceClass = '';
          let soldOutClass = 'is-hidden hidden';
          let fromClass = 'is-hidden hidden';
          let aosDelay = shown * 150;
          let aosImageDuration = shown * 100 + 800;
          let aosTextDuration = shown * 50 + 800;

          if (product.media.length > 1) {
            doubleImageClass = 'double__image';
          } else {
            bottomImageClass = 'is-hidden hidden';
          }

          for (let i = 0; i < product.tags.length; i++) {
            if (product.tags[i].includes('_badge_')) {
              customBadge = true;
              customBadgeVal = product.tags[i].replace('_badge_', '').split('_').join(' ');

              break;
            }

            if (product.tags[i].includes('_preorder')) {
              preorder = true;

              break;
            }
          }

          if (customBadge) {
            customBadgeClass = '';
          }

          if (preorder && !customBadge) {
            preorderClass = '';
          }

          if (product.compare_at_price > product.price) {
            priceClass = 'sale';
            saleClass = '';

            if (!preorder || !customBadge) {
              salePriceClass = '';
              saleClass = 'is-hidden hidden';
            }
          }

          if (!product.available) {
            preorderClass = 'is-hidden hidden';
            priceClass = 'is-hidden hidden';
            soldOutClass = '';
          }

          if (product.price_varies) {
            fromClass = '';
          }

          const stripHtmlRegex = /(<([^>]+)>)/gi;
          const productTitleStripped = product.title.replace(stripHtmlRegex, '');

          let markup = template.innerHTML;
          markup = markup.replace(/\|\|itemUrl\|\|/g, product.url);
          markup = markup.replace(/\|\|itemDoubleImageClass\|\|/g, doubleImageClass);
          markup = markup.replace(/\|\|itemTopImage\|\|/g, product.topImage);
          markup = markup.replace(/\|\|itemBottomImage\|\|/g, product.bottomImage);
          markup = markup.replace(/\|\|itemBottomImageClass\|\|/g, bottomImageClass);
          markup = markup.replace(/\|\|itemCustomBadgeClass\|\|/g, customBadgeClass);
          markup = markup.replace(/\|\|itemCustomBadgeVal\|\|/g, customBadgeVal);
          markup = markup.replace(/\|\|itemPreorderClass\|\|/g, preorderClass);
          markup = markup.replace(/\|\|itemSaleClass\|\|/g, saleClass);
          markup = markup.replace(/\|\|itemSalePriceClass\|\|/g, salePriceClass);
          markup = markup.replace(/\|\|itemPriceClass\|\|/g, priceClass);
          markup = markup.replace(/\|\|itemFromClass\|\|/g, fromClass);
          markup = markup.replace(/\|\|itemTitle\|\|/g, productTitleStripped);
          markup = markup.replace(/\|\|itemComparedPrice\|\|/g, product.compareFormatted);
          markup = markup.replace(/\|\|itemPrice\|\|/g, product.priceFormatted);
          markup = markup.replace(/\|\|itemHandle\|\|/g, product.handle);
          markup = markup.replace(/\|\|itemAosDelay\|\|/g, aosDelay);
          markup = markup.replace(/\|\|itemAosImageDuration\|\|/g, aosImageDuration);
          markup = markup.replace(/\|\|itemAosTextDuration\|\|/g, aosTextDuration);
          markup = markup.replace(/\|\|itemIndex\|\|/g, shown);
          markup = markup.replace(/\|\|itemSoldClass\|\|/g, soldOutClass);

          if (product.options[0].name === 'Title' && product.options.length === 1 && product.options[0].values[0] === 'Default Title') {
            markup = markup.replace(/\|\|itemHasOnlyDefault\|\|/g, 'data-quick-add-button');
          } else {
            markup = markup.replace(/\|\|itemHasOnlyDefault\|\|/g, '');
          }

          const colorArray = product.options.filter((option) => {
            for (let index = 0; index < theme.swatchLabels.length; index++) {
              const label = theme.swatchLabels[index].trim();

              if (Object.values(option).includes(label)) {
                return option;
              }
            }
          });

          markup = markup.replace(/\|\|itemSwatchesHidden\|\|/g, colorArray.length > 0 ? '' : 'hide');
          markup = markup.replace(/\|\|itemColorLabel\|\|/g, colorArray.length > 0 ? colorArray[0].name : '');

          wrapper.innerHTML += markup;

          productHandleQueue.shift();
          shown++;
          moveAlong(shown);
        })
        .catch(() => {
          cookie.remove(productHandleQueue[0]);
          productHandleQueue.shift();
          moveAlong(shown);
        });
    } else {
      finalize();
    }
  };

  return {
    showRecentlyViewed: function (params) {
      const paramsNew = params || {};
      const shown = 0;

      // Update defaults.
      Object.assign(config, paramsNew);

      // Read cookie.
      productHandleQueue = cookie.read();

      // Template and element where to insert.
      template = document.querySelector(`#${config.templateId}`);
      wrapper = document.querySelector(`#${config.wrapperId}`);

      // How many products to show.
      howManyToShowItems = config.howManyToShow;
      config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

      // If we have any to show.
      if (config.howManyToShow && template && wrapper) {
        // Getting each product with an Ajax call and rendering it on the page.
        moveAlong(shown);
      }
    },

    getConfig: function () {
      return config;
    },

    clearList: function () {
      cookie.destroy();
    },

    recordRecentlyViewed: function (params) {
      const paramsNew = params || {};

      // Update defaults.
      Object.assign(config, paramsNew);

      // Read cookie.
      let recentlyViewed = cookie.read();

      // If we are on a product page.
      if (window.location.pathname.indexOf('/products/') !== -1) {
        // What is the product handle on this page.
        const productHandle = decodeURIComponent(window.location.pathname)
          .match(
            /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
          )[0]
          .split('/products/')[1];
        // In what position is that product in memory.
        const position = recentlyViewed.indexOf(productHandle);

        // If not in memory.
        if (position === -1) {
          // Add product at the start of the list.
          recentlyViewed.unshift(productHandle);
          // Only keep what we need.
          recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
        } else {
          // Remove the product and place it at start of list.
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(productHandle);
        }

        // Update cookie.
        cookie.write(recentlyViewed);
      }
    },

    hasProducts: cookie.read().length > 0,
  };
})();
